import React from 'react';

export default function IntegratedFileCategorySelect({ label = 'Categoria do arquivo', value = '', options = [], loading, error, onChange }) {
  return (
    <div className="min-w-0">
      <label className="block text-sm font-medium text-slate-700">
      {label}
      <select value={value} disabled={loading || error} onChange={event => onChange(event.target.value)}
        className="mt-1 block w-full min-w-0 rounded border border-slate-300 bg-white px-2 py-2 text-sm disabled:bg-slate-100">
        <option value="">Sem categoria definida</option>
        {value && !options.includes(value) && <option value={value}>{value}</option>}
        {options.map(option => <option key={option} value={option}>{option}</option>)}
      </select>
      </label>
      {loading && <span className="mt-1 block text-xs font-normal text-slate-500">Carregando categorias…</span>}
      {error && <span role="alert" className="mt-1 block text-xs font-normal text-red-600">Não foi possível carregar as categorias. Reabra o campo para tentar novamente.</span>}
      {!loading && !error && !options.length && <span className="mt-1 block text-xs font-normal text-slate-500">Cadastre as categorias de arquivos nas configurações do módulo.</span>}
    </div>
  );
}
